import useState from "react-usestateref";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import {
  AppBar,
  Drawer,
  ListItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import "./style.css";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const Services = () => {
  const [menuopen, setMenuopn] = useState(false);
  const menuopenClose = () => {
    setMenuopn(true);
  };

  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <>
      {" "}
      <div className="main-bg service-bg">
        <section
          className={`${
            menuopen === true ? "menuopenzindex" : "menuclosezindex"
          }`}
        >
          <header className="main-header scrolled header-wrapper">
            <AppBar position="static" className="header_secondsec">
              <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
                <div className="hd_navigation">
                  <div
                    className="d-flex hd_nav_lft"
                    onClick={handleAboutLogoClick}
                  >
                    <Link className="logo-wrapper">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                  </div>

                  <div className="hd_nav_links_cntr">
                    <Link
                      to="/about"
                      className={`hd_nav_link ${isActive("about")}`}
                    >
                      About
                    </Link>
                    <Link
                      to="/services"
                      className={`hd_nav_link ${isActive("services")}`}
                    >
                      Services
                    </Link>
                    <Link
                      to="/projects"
                      className={`hd_nav_link ${isActive("projects")}`}
                    >
                      Projects
                    </Link>
                    <Link
                      to="/testimonials"
                      className={`hd_nav_link ${isActive("testimonials")}`}
                    >
                      Testimonials
                    </Link>
                  </div>

                  <div className="rightside_menu">
                    <div className="header_btn_wrap">
                      <button
                        className="header-btn"
                        onClick={() => navigate("/contact-us")}
                      >
                        <span className="phone_icon">
                          <FaPhoneAlt />
                        </span>
                        <span>Contact</span>
                      </button>

                      <button
                        className="header-btn"
                        onClick={() =>
                          window.open(
                            "https://beleaftechnologies.com/",
                            "_blank"
                          )
                        }
                      >
                        <span className="web_icon">
                          <TbWorld />
                        </span>
                        <span className="">Website</span>
                      </button>
                    </div>

                    {/* <div className="menu_img" onClick={menuopenClose}>
                      <span className="hamburger-menu">
                        <i className="fa-solid fa-bars"></i>
                      </span>
                    </div> */}
                  </div>
                  <div className="header_bars" onClick={handleMobileMenuOpen}>
                    <i className="fa-solid fa-bars"></i>
                  </div>
                </div>
              </Toolbar>
            </AppBar>

            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
            >
              <div className={` ${classes.mobileMenu}`}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <div
                    className="mobile_logo_wrap"
                    onClick={handleAboutLogoClick}
                  >
                    <img src={Logo} alt="logo" />
                  </div>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/about">
                      About
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/services">
                      Services
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/projects">
                      Projects
                    </Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/testimonials">
                      Testimonials
                    </Link>
                  </ListItem> */}

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span>Contact</span>
                    </button>
                  </ListItem>

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </ListItem>
                </div>
              </div>
            </Drawer>
          </header>

          <main>
            <div className="header-wrapper section-wrapper">
              <div className="container-fluid">
                <div>
                  <div className="row content-main">
                    <div className="col-lg-5  col-md-4">
                      <div className="getting_card_content">
                        <span className="getcard_sub_subhead padding-right">
                          What we can
                        </span>
                        <h1>Services</h1>
                        <p>
                          We’re here to support all your blockchain development
                          needs with expert solutions that keep your business
                          running smoothly and securely.
                        </p>
                        <p>
                          Whether you're streamlining processes or integrating
                          new technologies, our team provides custom services to
                          help you innovate and stay ahead in the digital
                          landscape.
                        </p>
                        <div
                          className="d-flex mainicons_div about-get-in-touch"
                          data-toggle="modal"
                          data-target="#myModal"
                        >
                          <p>Get in Touch</p>
                          <span onClick={() => navigate("/contact-us")}>
                            <IoMdCall />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                      <div className="footer_second_main">
                        <span className="footer_head">Web3 solutions</span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              Web3 solutions
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              Crypto development services
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              L1 & L2 Blockchain solutions
                            </span>
                          </Link>
                        </div>
                        <span className="footer_head">
                          Software development
                        </span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              Nearshore software development
                            </span>
                          </Link>
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              Agile software development
                            </span>
                          </Link>
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              Custom software development{" "}
                            </span>
                          </Link>
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              Offshore development service
                            </span>
                          </Link>
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              CRM development
                            </span>
                          </Link>
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/custom-software-development-company"
                          >
                            <span className="footer_links_span">
                              ERP software development
                            </span>
                          </Link>
                        </div>
                        <span className="footer_head">Forex Trading</span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link
                            to=""
                            // target="_blank"
                            // href="https://beleaftechnologies.com/forex-trading-software-development"
                          >
                            <span className="footer_links_span">
                              Forex Trading Development
                            </span>
                          </Link>
                        </div>

                        <span className="footer_head">
                          Legal Compliance Service
                        </span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              VARA License
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              FIU India registration
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                      <div className="footer_second_main">
                        <span className="footer_head">Web app development</span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              Progressive web app Development
                            </span>
                          </Link>
                        </div>
                        <span className="footer_head">
                          Mobile app development
                        </span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              IOS app development
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              Android app development
                            </span>
                          </Link>
                        </div>

                        <span className="footer_head">Stock</span>
                        <span className="border_services"></span>

                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              Stock exchange development
                            </span>
                          </Link>
                        </div>

                        <span className="footer_head">Trading Bot</span>
                        <span className="border_services"></span>
                        <div className="footer_links_div">
                          <Link to="">
                            <span className="footer_links_span">
                              Crypto trading bot
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              Forex trading bot
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              Stock trading bot
                            </span>
                          </Link>
                          <Link to="">
                            <span className="footer_links_span">
                              Gold trading bot
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </section>
      </div>
    </>
  );
};

export default Services;
